const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`_table_class`] = ``;
                this.echo(`
`);
                if ((context.has(`numericData`) ? context.get(`numericData`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_table_class`] = ((context.has(`_table_class`) ? context.get(`_table_class`) : null) + ` c-table--numeric`);
                }
                this.echo(`
`);
                if ((context.has(`isRuled`) ? context.get(`isRuled`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_table_class`] = ((context.has(`_table_class`) ? context.get(`_table_class`) : null) + ` c-table--ruled`);
                }
                this.echo(`
`);
                if ((context.has(`isStriped`) ? context.get(`isStriped`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_table_class`] = ((context.has(`_table_class`) ? context.get(`_table_class`) : null) + ` c-table--striped`);
                }
                this.echo(`
`);
                this.echo(this.include(context, this.source, this.loadTemplate(`b64e7e59985ef3c289b97735b09bbd9264111236bb7e4c3baac3e9d1bdaab83a`, `b64e7e59985ef3c289b97735b09bbd9264111236bb7e4c3baac3e9d1bdaab83a`, 15, 113), new Map([[`table_class`, (context.has(`_table_class`) ? context.get(`_table_class`) : null)]]), true, false, 15));
            }

            getTemplateName() {
                return `b64e7e59985ef3c289b97735b09bbd9264111236bb7e4c3baac3e9d1bdaab83a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `b64e7e59985ef3c289b97735b09bbd9264111236bb7e4c3baac3e9d1bdaab83a`, ``);
            }
        }],
        [113, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/table/table.twig`, `b64e7e59985ef3c289b97735b09bbd9264111236bb7e4c3baac3e9d1bdaab83a`, 15);

                this.blocks = new Map([
                    ['caption', [this, 'block_caption']],
                    ['header', [this, 'block_header']],
                    ['body', [this, 'block_body']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/table/table.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_caption(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                if ((context.has(`hasCaption`) ? context.get(`hasCaption`) : null)) {
                    this.echo(`        Comparing popular Cloud Four projects on GitHub.
    `);
                }
                this.echo(`  `);
            }

            block_header(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                if ((context.has(`hasHeader`) ? context.get(`hasHeader`) : null)) {
                    this.echo(`      <tr>
        <th></th>
        <th scope="col">Stars</th>
        <th scope="col">Forks</th>
        <th scope="col">Watchers</th>
        <th scope="col">Issues</th>
      </tr>
    `);
                }
                this.echo(`  `);
            }

            block_body(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`tableData`) ? context.get(`tableData`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`row`] = __value__;
                    this.echo(`      <tr>
        <th scope="row">
          <a href="https://github.com/cloudfour/`);
                    this.echo(this.env.getFilter('escape').traceableCallable(39, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 39, this.source)(this.env, context.get(`row`), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(39, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 39, this.source)(this.env, context.get(`row`), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</a>
        </th>
        <td>
          <a href="https://github.com/cloudfour/`);
                    this.echo(this.env.getFilter('escape').traceableCallable(42, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 42, this.source)(this.env, context.get(`row`), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`/stargazers">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(42, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 42, this.source)(this.env, context.get(`row`), `stargazers`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</a>
        </td>
        <td>
          <a href="https://github.com/cloudfour/`);
                    this.echo(this.env.getFilter('escape').traceableCallable(45, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 45, this.source)(this.env, context.get(`row`), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`/network/members">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(45, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 45, this.source)(this.env, context.get(`row`), `forks`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</a>
        </td>
        <td>`);
                    this.echo(this.env.getFilter('escape').traceableCallable(47, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 47, this.source)(this.env, context.get(`row`), `followers`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</td>
        <td>
          <a href="https://github.com/cloudfour/`);
                    this.echo(this.env.getFilter('escape').traceableCallable(49, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 49, this.source)(this.env, context.get(`row`), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`/issues">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(49, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 49, this.source)(this.env, context.get(`row`), `issues`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</a>
        </td>
      </tr>
    `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('row');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                if ((context.has(`hasFooter`) ? context.get(`hasFooter`) : null)) {
                    this.echo(`      <tr>
        <th scope="row">Total:</th>
        <td>2125</td>
        <td>234</td>
        <td>2125</td>
        <td>245</td>
      </tr>
    `);
                }
                this.echo(`  `);
            }

            getTemplateName() {
                return `b64e7e59985ef3c289b97735b09bbd9264111236bb7e4c3baac3e9d1bdaab83a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `b64e7e59985ef3c289b97735b09bbd9264111236bb7e4c3baac3e9d1bdaab83a`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'b64e7e59985ef3c289b97735b09bbd9264111236bb7e4c3baac3e9d1bdaab83a');

let template = env.loadTemplate('b64e7e59985ef3c289b97735b09bbd9264111236bb7e4c3baac3e9d1bdaab83a');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/table/demo/basic.twig", args: context }
     );
     return rendered;;
};